export default __webpack_public_path__ + "static/media/userIcon.6c53c0a1.png";